var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"mobile-warning-modal","height":"auto"}},[_vm._v(" Heyo! 👋 Serv here."),_c('br'),_vm._v(" Just a heads up the layout on mobile works, but is pretty scuffed."),_c('br'),_vm._v(" I'd recommend trying desktop until I get around to making mobile not so shitty :3 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }